import i18next from "src/i18n/config";

import { ProductEvents } from "@dashboard/devices/types";
import { getEventColors } from "@dashboard/overview/components/EventChartCard/EventChartCard.utils";
import { Theme } from "@mui/material";

import { getActorTitle } from "./shared/eventHelpers";
import type { EventContentResult, EventContext, RendererProps } from "./shared/eventTypes";
import { renderUnknownEventContent } from "./unknown";

type ProductChangedEvent = Extract<ProductEvents, { eventTypeName: "ProductEvent.Changed" }>;
const renderProductChanged = (props: RendererProps<ProductChangedEvent>): EventContentResult | null => {
    const { event, theme } = props;
    const eventColors = getEventColors(theme);
    const actorTitle = getActorTitle(event);

    const actorLabel = actorTitle ?? i18next.t("common:status.unknown");

    return {
        color: eventColors[event.level],
        header: i18next.t("modals:eventModals.productChangedTitle"),
        component: i18next.t("modals:eventModals.productChangedDescription", {
            actorTitle: actorLabel,
            entityId: event.entityId,
        }),
    };
};

type ProductDeletedEvent = Extract<ProductEvents, { eventTypeName: "ProductEvent.Deleted" }>;
const renderProductDeleted = (props: RendererProps<ProductDeletedEvent>): EventContentResult | null => {
    const { event, theme } = props;
    const eventColors = getEventColors(theme);
    const actorTitle = getActorTitle(event);

    const actorLabel = actorTitle ?? i18next.t("common:status.unknown");

    return {
        color: eventColors[event.level],
        header: i18next.t("modals:eventModals.productDeletedTitle"),
        component: i18next.t("modals:eventModals.productDeletedDescription", {
            actorTitle: actorLabel,
            entityId: event.entityId,
        }),
    };
};

export const renderProductEventContent = (
    event: ProductEvents,
    context: EventContext,
    theme: Theme,
): EventContentResult | null => {
    switch (event.eventTypeName) {
        case "ProductEvent.Changed":
            return renderProductChanged({ event, context, theme });
        case "ProductEvent.Deleted":
            return renderProductDeleted({ event, context, theme });
        default:
            return renderUnknownEventContent({ event, context, theme });
    }
};
